import { render, staticRenderFns } from "./myAside.vue?vue&type=template&id=7edd473a&scoped=true"
import script from "./myAside.vue?vue&type=script&lang=js"
export * from "./myAside.vue?vue&type=script&lang=js"
import style0 from "./myAside.vue?vue&type=style&index=0&id=7edd473a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd473a",
  null
  
)

export default component.exports